export default __webpack_public_path__ + "faee0b6fdd3b0aca07e0c0eef4996130.png";